<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M4.159 22.96c-.12-.065-.161-.189-.095-.29l.477.255a.338.338 0 01-.217.075.35.35 0 01-.165-.04zM18.734 9L5.29 21.544l5.163-8.963.432-.75H4.73l5.896-9.33h8.488l-5.461 5.653-.819.847h5.899z"/>
</svg>
